import React, { HTMLAttributes } from "react";

import {
  MenuItem as ReachMenuItem,
  MenuItemImplProps,
} from "@reach/menu-button";

type MenuItemProps = Pick<
  MenuItemImplProps,
  "children" | "disabled" | "index" | "valueText"
> &
  Partial<Pick<MenuItemImplProps, "onSelect">> & HTMLAttributes<HTMLDivElement>;

const MenuItem: React.FC<MenuItemProps> = ({
  children,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onSelect = () => {},
  ...props
}) => {
  return (
    <ReachMenuItem onSelect={onSelect} {...props}>
      {children}
    </ReachMenuItem>
  );
};

export default React.memo(MenuItem);
